// @ts-nocheck
import {createScriptTag} from './Helper.client';

export const delayThirdPartyScripts = (): void => {
    window.requestIdleCallback(() => {
        createScriptTag(
            null,
            __BENTO_SCRIPT_URL__
        );
        createScriptTag(`var bento_event_queue  = [];  bento_event_queue.push(["bento.view()"]);`);
    }, { timeout: 7000 });
};
